import React, { useEffect, useState } from "react";
import "./risk.scss";
import { Avatar, Button, Col, Divider, Input, Row, Typography } from "antd";

import { HandleErrors } from "../../../../utils/handleErrors";
import { toast } from "react-toastify";
import {
  getAllEventRiskService,
  updateEventRiskService,
} from "../../../../services/risk.service";
import {
  GetEventRiskRes,
  UpdateEventRiskReq,
} from "../../../../interfaces/eventRisk.interface";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { GetPermissionRes } from "../../../../interfaces/role.interface";
import { PermissionCode } from "../../../../enum/permission";

const Risk = () => {
  const userPermissions = useSelector<RootState, GetPermissionRes[]>(
    (root) => root.user.permissions
  );
  const [loading, setLoading] = useState(false);

  const [risks, setRisks] = useState<GetEventRiskRes[]>([]);

  useEffect(() => {
    getRisks();
  }, []);

  const getRisks = async () => {
    try {
      const res = await getAllEventRiskService({});
      setRisks(res.list);
    } catch (error) {
      HandleErrors(error);
    }
  };

  const update = async () => {
    try {

      setLoading(true);
      for(const risk of risks){
        await updateEventRiskService({
          id: risk.id,
          risk: risk.risk
        });
      }
      
      toast.success("تغییرات با موفقیت ثبت شد");
      setLoading(false);
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  return (
    <div className="OrganizationRisk">
      <Row align={"middle"} justify={"start"} className="title-box">
        <Col>
          <Typography.Text className="title">مدیریت ریسک</Typography.Text>
        </Col>
      </Row>

      <div className="info-box">
        <Row align={"middle"} justify={"start"}>
          {risks.map((item, index) => {
            if(item.code == 'start_app'){
              return
            }
            return (
              <Col md={8} xs={24}>
                <div className="input-box">
                  <Typography.Text className="title">{item.name}</Typography.Text>
                  <Input className="input" value={item.risk} onChange={(e)=>{
                    const temp = [...risks];
                    temp[index].risk = Number(e.target.value)
                    setRisks(temp)
                  }} />
                </div>
              </Col>
            );
          })}
        </Row>
        {userPermissions.find(p => p.code === PermissionCode.updateEventRisk) && <Row justify={"end"}>
          <Col md={3} xs={24} className="btn-box">
            <Button loading={loading} onClick={update} className="btn" type="primary" block>
              ذخیره
            </Button>
          </Col>
        </Row>}
      </div>

      {/* {risks.map((item, index) => {
        if(item.code == 'start_app'){
          return
        }
        return (
          <div className="info-box">
            <Row>
              <Col>
                <Typography.Text className="title">{item.name}</Typography.Text>
              </Col>
            </Row>
 
            <Divider />
            <Row justify={"space-between"} align={"bottom"}>
              <Col xs={21} className="input-box">
                <Input
                  className="input"
                  
                  value={item.risk}
                  onChange={(e)=>{
                    const t = [...risks];
                    t[index].risk = parseInt(e.target.value);
                    setRisks(t);
                  }}
                />
              </Col>
              <Col xs={3} className="btn-box">
                {userPermissions.find(p => p.code === PermissionCode.updateEventRisk) && <Button loading={loading === item.id} onClick={()=>{
                  update(item)
                }} type="primary" block className="btn">
                  ذخیره
                </Button>}
              </Col>
            </Row>
          </div>
        );
      })} */}
    </div>
  );
};

export default Risk;
